<template>
  <Dialog :open="isOpen">
    <DialogContent class="max-h-screen overflow-scroll sm:max-w-[500px]" hideClose>
      <DialogHeader>
        <DialogTitle class="mb-2">{{ t('missingDetails.title') }}</DialogTitle>
        <DialogDescription>{{ t('missingDetails.description') }}</DialogDescription>
      </DialogHeader>
      <UserDetailsForm
        class="!mb-0 !mt-0 w-full pb-0"
        :collectFields="collectFields"
        :requiredRules="requiredRules"
        :initialValues="fanData"
        emailDisabled
        :error="fanPatchError?.message"
        :success="fanPatchData ? t('profile.success') : undefined"
        :isSubmitting="isSubmitting"
        :isLoading="isFanFetching"
        @clearError="clearError"
        @clearSuccess="clearSuccess"
        @submit="onSubmit"
      />
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFanStore } from '@stores/fan.store';
import { type UserDetails } from '@modules/UserDetailsForm/UserDetails.interface';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ui/dialog';
import UserDetailsForm from '@modules/UserDetailsForm/UserDetailsForm.vue';

defineProps<{
  isOpen: boolean;
}>();

const { t } = useI18n();
const fanStore = useFanStore();
const { fanData, fanPatchData, fanPatchError, isFanFetching } = storeToRefs(fanStore);
const isSubmitting = ref(false);

const collectFields = computed(() => ({
  firstName: !fanData?.value?.firstName,
  lastName: !fanData?.value?.lastName,
  email: !fanData?.value?.email,
  location: !fanData?.value?.location || Object.keys(fanData?.value?.location).length === 0,
  phoneNumber: !fanData?.value?.phoneNumber,
  birthDate: !fanData?.value?.birthDate,
  // consentEmail: !fanData?.value?.email || (fanData?.value?.email && !fanData?.value?.consentEmail),
  // consentMessaging:
  //   !fanData?.value?.phoneNumber || (fanData?.value?.phoneNumber && !fanData?.value?.consentMessaging),
}));

const requiredRules = {
  firstName: true,
  lastName: true,
  email: true,
  location: true,
  phoneNumber: true,
  birthDate: true,
  consentEmail: false,
  consentMessaging: false,
};

const onSubmit = async (formData: UserDetails) => {
  isSubmitting.value = true;
  await fanStore.fanPatch(formData);
  if (fanPatchError.value) return;
  fanStore.fanGet();
  isSubmitting.value = false;
};

const clearError = () => {
  fanPatchError.value = null;
};

const clearSuccess = () => {
  fanPatchData.value = null;
};
</script>
